/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./pageLoadProgress.vue?vue&type=template&id=72236f8f&"
import script from "./pageLoadProgress.vue?vue&type=script&lang=js&"
export * from "./pageLoadProgress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports